<template>
  <div
    class="roster-time-input-frame"
    :title="helpText"
  >
    <CInput class="preika-control-frame--time"
      type="time"
      maxlength="5"
      style="margin-bottom: 3px"
      :value="displayValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      :tabindex="tabindex"
      @focus="onFocus"
      @blur="onBlur"
    />
    <small
      v-if="flg && !disabled"
      class="roster-auto-rest-note"
    >
      {{ manualEdited ? '実績へ手動修正済み' : '定時後休憩を自動反映' }}
    </small>
  </div>
</template>

<script>
export default {
  name: "RestInput",
  props: {
    rest: String,
    index: Number,
    postBuffer: String,
    breakBasic: String,
    flg: Boolean,
    isHoliday: Boolean,
    actualEnd: String,
    endBasic: String,
    tabindex: Number,
    label: String,
    disabled: Boolean,
    placeholder: String,
  },
  emits: ["update-rest", "focus", "blur"],
  data() {
    return {
      manualEdited: false,
    };
  },
  computed: {
    displayValue() {
      if (this.isHoliday) return "";
      return /^\d{2}:\d{2}$/.test(this.rest || "") ? this.rest : "";
    },
    helpText() {
      if (!this.flg) {
        return "実際に労働から離れていた休憩時間を入力してください。";
      }
      return "定時直後休憩を設定値から自動反映します。作業・待機・電話対応等があった時間は休憩ではないため、実績へ修正してください。手動修正後は自動再計算で上書きしません。";
    },
  },
  methods: {
    onInput(val) {
      if (this.disabled) return;
      this.manualEdited = true;
      this.$emit("update-rest", { index: this.index, value: val });
    },
    onFocus() {
      this.$emit("focus");
    },
    onBlur() {
      this.$emit("blur");
    }
  }
};
</script>

<style scoped>
.roster-time-input-frame {
  position: relative;
  width: 112px;
  min-width: 112px;
  min-height: 40px;
}

.roster-auto-rest-note {
  display: block;
  margin-top: -2px;
  color: #5c6770;
  font-size: 9px;
  line-height: 1.25;
  white-space: normal;
}
</style>
